import { useBehavior } from '@libs/core';
import { TCommonData, TWidgetProps } from '@libs/types';
import React from 'react';
import { TTextOption } from '../../types/options';
import { AppVersionTextView } from './AppVersionTextView';

export const AppVersionText: React.FC<TWidgetProps<TCommonData, TTextOption>> = ({ widget }) => {
    const { isHidden, isDisabled } = useBehavior(widget);

    const options = widget.options ?? {};

    return (
        <AppVersionTextView
            widget={widget}
            uid={widget.uid}
            platform={widget.data?.value as string | undefined}
            styleName={options.style}
            textColor={options.textColor}
            textAlign={options.textAlign}
            maxLines={options.maxLines}
            margin={options.margin}
            isHide={isHidden}
            isDisabled={isDisabled}
        />
    );
};
